module.exports = __webpack_public_path__ + "media/images/ui__textArrowDownLight-3df714cae318fc66d6f56671eebe1a9c.png";